import './index.less';

import request from '@/utils/request';
import { divide } from '@umijs/deps/compiled/lodash';
import { Modal } from 'antd-mobile';
import { url } from 'inspector';
import { getLocale, history, useIntl } from 'umi';
import { formatMessage } from 'umi';

const customStyle = {
  body: {
    backgroundColor: 'red',
  },
};

//@ts-ignore
// 观看本地存储
export const setSearchHistory = (value: string): void => {
  if ('searchHistoryData' in localStorage) {
    let searchHistoryData = JSON.parse(localStorage['searchHistoryData']);
    if (searchHistoryData.includes(value)) {
      searchHistoryData = searchHistoryData.filter((item: any) => {
        return item !== value;
      });
    } else if (searchHistoryData.length >= 16) {
      searchHistoryData.splice(0, 1);
    }
    searchHistoryData.push(value);

    localStorage.setItem(
      'searchHistoryData',
      JSON.stringify(searchHistoryData),
    );
  } else {
    localStorage.setItem('searchHistoryData', JSON.stringify([value]));
  }
};

//观看记录本地获取
export const getSearchHistory = () => {
  if ('searchHistoryData' in localStorage) {
    let searchHistoryData = JSON.parse(
      localStorage['searchHistoryData'],
    ).reverse();
    return searchHistoryData;
  } else {
    return;
  }
};

// 删除观看记录
export const deleteSearchHistory = (): void => {
  if ('searchHistoryData' in localStorage) {
    localStorage.removeItem('searchHistoryData');
  } else {
    return;
  }
};

//获取首页当前栏目标识
export const getCurrent = (arr: []) => {
  let num;
  if (location.search.indexOf('?itemId') !== -1) {
    const itemId = location.search.split('itemId=')[1];
    num = arr.findIndex((item: any) => item.itemId === itemId);
  } else {
    num = arr.findIndex((item: any) => item.content === '1');
  }
  return num === -1 ? 0 : num;
};

// 鉴权
export const check = async (origin: any, itemObj?: any) => {
  const Url = `${process.env.BMSUrl}bms/user/ctmlogin/checkCTMProfileReq?version=1`;
  const res = await request.post(Url, {
    data: {
      accountId: localStorage.getItem('accountId'),
      lang: `${getLocale().replace(/-/gi, '_')}`,
      userId: localStorage.getItem('userId'),
      userToken: localStorage.getItem('userToken'),
      ctmNumber: localStorage.getItem('accountId'),
      origin: origin,
      platformCode: `${process.env.BMSsiteId}`,
    },
  });
  if (res.code === 200 && origin === '16') {
    window.open('https://glb.m.mgtv.com/channel/home', 'location=no');
  }
  if (res.code === 200 && origin === '21') {
    window.open(itemObj?.link, 'location=no');
  } else if (res.code === 3001) {
    history.push({
      state: {
        origin: origin,
      },
      pathname: '/order',
    });
  } else if (res.code === 205 || res.code === 206) {
    Modal.alert(
      formatMessage({
        id: 'toast.page.processed',
      }),
      '',
      [
        {
          text: formatMessage({
            id: 'order.page.close',
          }),
          onPress: () => console.log('cancel'),
        },
      ],
    );
  }
};
function getQueryString(name: any, urlstring: any) {
  const url = new URL(urlstring);
  return url.searchParams.get(name);
}
// 全局元素子集跳转统一处理
export const globalJump = (itemObj: any) => {
  console.log(itemObj);
  if (itemObj.assetFrom == 'tvb') {
    check('21', itemObj);
    return;
  }
  const layout = itemObj.layout ? itemObj.layout : itemObj.layout2;
  const Url = itemObj.jsonUrl ? itemObj.jsonUrl : itemObj.layoutUrl;
  const detailUrl = Url.includes(`http://epg.cmishow.com/`)
    ? Url.replace('http://epg.cmishow.com/', `${process.env.baseUrl}`)
    : Url;
  console.log(Url);
  if (itemObj.assetFrom && itemObj.assetFrom === 5) {
    //hmovd
    let hmovdDetailUrl = `https://m.anyplex.com:443/api_v2/detail?appVersion=1.0.31&buildVersion=31&deviceModel=chrome&deviceSerial=1&network=wifi&osVersion=30&platform=ctm&language=${getLocale().replace(
      /-/gi,
      '_',
    )}&token=${localStorage.getItem(
      'token',
    )}&areaCode=853&mobileno=${localStorage.getItem(
      'accountId',
    )}&programId=${getQueryString('programId', Url)}`;
    history.push({
      state: {
        detailUrl: hmovdDetailUrl,
        item: itemObj,
      },
      pathname: '/hmvod/detail',
    });
  } else if (itemObj.assetFrom && itemObj.assetFrom === 3) {
    check('16'); //芒果
  } else if (itemObj.assetFrom && itemObj.assetFrom === 15) {
    check('15');
  } else if (itemObj.assetFrom && itemObj.assetFrom === 6) {
    history.push({
      state: {
        detailUrl: detailUrl,
        layout: itemObj.layout,
        item: itemObj,
      },
      pathname: '/game/detail',
    });
  } else {
    switch (layout) {
      case 'CTM_Page_Detail_Movie_Picture':
      case 'CTM_Page_Detail_Series_Picture':
        history.push({
          state: {
            detailUrl: detailUrl,
            layout: layout,
            item: itemObj,
          },
          pathname: '/detail',
        });
        break;

      case 'CTM_Page_Detail_News_Picture':
        history.push({
          state: {
            detailUrl: detailUrl,
            layout: layout,
            item: itemObj,
          },
          pathname: '/detail',
        });
        break;

      case 'Category_Sort':
        window.location.href = `${
          window.location.href.split('home')[0]
        }home?itemId=${itemObj.itemId}`;
        break;
      case 'app_more':
      case 'app_special_list':
      case 'CTM_Page_Subject_Picture_New':
        history.push({
          state: {
            jsonUrl: detailUrl,
            layout: itemObj.layout,
            item: itemObj,
          },
          pathname: '/special',
        });
        break;
      case 'CTM_Page_Url': //兼容老版本 广告位跳转
        if (detailUrl.includes('ctm-activity')) {
          window.location.href = `${detailUrl}?l=${getLocale().replace(
            /-/gi,
            '_',
          )}&userId=${localStorage.getItem('accountId')}`;
        } else {
          window.location.href = detailUrl;
        }
        break;
      case 'CTM_Mango_Page_Url': //兼容老版本 广告位跳转
        check('16');
        //
        break;
      case 'CTM_Page_Detail_Cloud_Game':
      case 'CTM_Page_Detail_Cloud_Game_O':
        history.push({
          state: {
            detailUrl: detailUrl,
            layout: itemObj.layout,
            item: itemObj,
          },
          pathname: '/game/detail',
        });
        break;
      case 'CTM_Page_Detail_YTB':
        history.push({
          state: {
            detailUrl: detailUrl,
            layout: layout,
            item: itemObj,
          },
          pathname: '/detail',
        });
        break;
      case 'CTM_Category_Page_Vod_Live':
        history.push({
          state: {
            detailUrl: detailUrl,
            layout: layout,
            item: itemObj,
          },
          pathname: '/live/liveDetail',
        });
        break;
      case 'UTV_App_Page_Detail_Movie':
        history.push({
          state: {
            detailUrl: itemObj.jsonUrl,
            layout: layout,
            item: itemObj,
          },
          pathname: '/detail',
        });
        break;
      default:
        console.log('没有对应的layout' + JSON.stringify(itemObj));
    }
  }
};

// 全局全球化语言处理
export const getLocaleText = (textId: string) => {
  const intl = useIntl();
  return intl.formatMessage({
    id: textId,
  });
};

//国际化时间
export function formatDate(dateString: any, locale: any) {
  const targetDate = new Date(dateString);

  const chineseOptions = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  };

  const englishOptions = {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // Display time in 24-hour format
  };

  const formatter = new Intl.DateTimeFormat(
    locale === 'en-US' ? 'en-US' : 'zh-CN',
    locale === 'en-US' ? englishOptions : chineseOptions,
  );

  return formatter.format(targetDate);
}

// 倒计时
export function calculateCountdown(targetDate: any) {
  let time = { hours: '00', minutes: '00', seconds: '00' };
  const targetTime = new Date(targetDate).getTime();
  const currentTime = Date.now();
  const timeDifference = targetTime - currentTime;

  if (timeDifference <= 0) {
    return 'end';
  }

  // Calculate hours, minutes, and seconds from the time difference
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
  time = {
    hours: hours < 10 ? `0${hours}` : hours.toString(),
    minutes: minutes < 10 ? `0${minutes}` : minutes.toString(),
    seconds: seconds < 10 ? `0${seconds}` : seconds.toString(),
  };
  return time;
}
// 时间格式化
export function formatTime(timeString: any) {
  const givenTime = new Date(timeString);
  const currentTime = new Date();

  // Check if the given time is today
  if (
    givenTime.getDate() === currentTime.getDate() &&
    givenTime.getMonth() === currentTime.getMonth() &&
    givenTime.getFullYear() === currentTime.getFullYear()
  ) {
    // Format the time as "今日11:03:08"
    const formattedTime = `今日${formatNumber(
      givenTime.getHours(),
    )}:${formatNumber(givenTime.getMinutes())}:${formatNumber(
      givenTime.getSeconds(),
    )}`;
    return formattedTime;
  }

  // If the given time is not today, format it as "yyyy-MM-dd HH:mm:ss"
  const formattedTime = `${givenTime.getFullYear()}-${formatNumber(
    givenTime.getMonth() + 1,
  )}-${formatNumber(givenTime.getDate())} ${formatNumber(
    givenTime.getHours(),
  )}:${formatNumber(givenTime.getMinutes())}:${formatNumber(
    givenTime.getSeconds(),
  )}`;
  return formattedTime;
}

function formatNumber(num: any) {
  return num < 10 ? `0${num}` : num.toString();
}
//秒数倒计时
export function formatCountdown(seconds: number) {
  if (seconds <= 0) {
    return '00:00';
  }

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Pad single-digit values with leading zeros
  const formattedHours = hours < 10 ? `0${hours}` : hours.toString();
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes.toString();
  const formattedSeconds =
    remainingSeconds < 10
      ? `0${remainingSeconds}`
      : remainingSeconds.toString();

  // Create the countdown format
  const countdownFormat = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

  return countdownFormat;
}

// Example usage to update the countdown every second
